// extracted by mini-css-extract-plugin
export default {"card":"D1-z"};